export const extractQueryParameters = (url: string): Record<string, string> => {
	const queryString = url.split("?")[1];
	if (!queryString) {
		return {};
	}

	const params = queryString.split("&");
	const parameterObject: Record<string, string> = {};

	params.forEach((param) => {
		const [key, value] = param.split("=");
		parameterObject[key] = decodeURIComponent(value);
	});

	return parameterObject;
};
